<div class="flex-container">
  <div class="flex-items">
    <dx-select-box #activeKlantSelectBox id="activeKlantSelectBox"
      *ngIf="customers?.length > 1 && !PresenterModusEnabled" [items]="customers" width="300px" valueExpr="KlantId"
      displayExpr="NaamEnDemo" (onSelectionChanged)="onSelectionChanged($event)"></dx-select-box>
  </div>

  <div class="flex-items">
    <div *ngIf="customers?.length <= 1 || PresenterModusEnabled" class="activeCustomerName header-field">
      <span>{{activeCustomer.NaamEnDemo}}</span>
    </div>
  </div>

  <div class="flex-items" *ngIf="!PresenterModusEnabled">
    <dx-select-box #activeAfdelingSelectBox [items]="activeCustomer.Afdelingen" width="300px" valueExpr="AfdelingId"
      displayExpr="Naam" (onSelectionChanged)="onAfdelingChanged($event)" [visible]="showDepartmentBox"></dx-select-box>
  </div>
</div>

<!-- <div *ngIf="activeCustomer?.Afdelingen.length <= 1" class="activeCustomerName"><span>gekozen afdeling</span></div> -->

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Bezig met wisselen....">
</dx-load-panel>